<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <md-progress-bar
        v-if="loading"
        md-mode="query"
      />
      <div v-else>
        <md-card>
          <md-card-content>
            <h3 class="md-headline h2">
              {{ app.identity }}
            </h3>
            <form>
              <md-field class="short-field">
                <label>ID</label>
                <md-input
                  v-model="app.id"
                  disabled
                />
              </md-field>

              <md-field class="short-field">
                <label>Name</label>
                <md-input v-model="app.name" />
              </md-field>

              <md-field
                class="short-field"
                :class="$v.app.platform.$invalid && 'md-invalid invalid-field'"
              >
                <label>Platform</label>
                <md-input v-model="app.platform" />
                <span class="md-error">Field must not be empty</span>
              </md-field>

              <md-field class="short-field">
                <label>secret</label>
                <md-input v-model="app.secret" />
                <md-icon
                  v-clipboard:copy="app.secret"
                  class="gen-key"
                >
                  assignment
                </md-icon>
              </md-field>

              <md-field
                class="short-field"
                :class="$v.app.identity.$invalid && 'md-invalid invalid-field'"
              >
                <label>identity</label>
                <md-input v-model="app.identity" />
                <span class="md-error">Field must not be empty</span>
              </md-field>

              <md-field class="short-field">
                <label>app_url</label>
                <md-input v-model="app['app_url']" />
              </md-field>
            </form>
          </md-card-content>

          <md-card-actions>
            <md-button
              type="submit"
              class="md-primary"
              :disabled="loadingSubmission || $v.$invalid"
              @click.native="submitApp"
            >
              <span v-if="!loadingSubmission">Save</span>
              <md-progress-spinner
                v-else
                :md-diameter="15"
                :md-stroke="3"
                md-mode="indeterminate"
              />
            </md-button>
          </md-card-actions>
        </md-card>

        <app-config :app-identity="app.identity" />

        <md-card>
          <div class="md-subheading table-header">
            <div>Products</div>
            <md-button :to="`/app/${appId}/product/new`">
              New product
            </md-button>
          </div>
          <md-card-content>
            <app-table :app-id="appId" />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
    import { AppConfig, AppTable } from "@/components";
    import { required } from "vuelidate/lib/validators";

    export default {
        components: {
            AppConfig,
            AppTable
        },
        data() {
            return {
                appId: this.$route.params.appid,
                app: {
                    identity: null
                },
                loading: true,
                loadingSubmission: false,
            };
        },
        mounted() {
            this.fetchApp();
        },
        methods: {
            fetchApp() {
                this.loading = true;
                this.$http.get(`/v1/admin/store/app/${this.appId}`).then(result => {
                    this.app = result.data.app;
                    this.loading = false;
                }, err => {
                    console.error(err);
                });
            },
            submitApp() {
                this.loadingSubmission = true;
                this.$http.post("/v1/admin/store/app/update", this.app)
                    .then(res => {
                        this.loadingSubmission = false;
                        console.log(res);
                    })
                    .catch(err => console.log(err));
            }
        },
        validations: {
            app: {
                platform: { required },
                identity: { required }
            }
        }
    };
</script>
<style scoped lang="scss">
    .short-field {
        width: 600px;
    }

    .table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 30px 15px 30px;
        a {
            margin: 0;
        }
    }

    .invalid-field {
        color: #ff1745;
        input, label {
            color: #ff1745 !important;
        }
    }
</style>
